export default __webpack_public_path__ + "static/media/bithu_roadmap_mash_Grad.278685b4.png";